;(function () {
  'use strict';
  /**
   * background-imageにmaster画像を設定する
   */

  $('.js-report-get-master-image').each(function () {

    var self = $(this);
    var title = $(this).closest('.search-master-form').find('.js-master-keyword-search').val();
    setMasterImage(self, title);
  });

}.call(this));
